import { getAvatar } from '@innovamat/glimmer-assets';
import type { Roles } from '@innovamat/radiance-utils';
import { hasOwnerRole } from '@innovamat/radiance-utils';
import type { OrganizationTeacher } from '../../modules/teacher/teacher';

type AvatarProps = {
  img?: string | null;
  name?: string | null;
};

const mapAvatar = (teacher: OrganizationTeacher | null) =>
  teacher?.classrooms?.map((c) => ({
    img: c?.icon ? getAvatar(c?.icon, c.courseOrder!) : '',
    name: c?.name,
  }));

const sortByOwner = (aRow: OrganizationTeacher, bRow: OrganizationTeacher) => {
  const a = hasOwnerRole(aRow?.roles as Roles[]);
  const b = hasOwnerRole(bRow?.roles as Roles[]);
  return a === b ? 0 : a ? -1 : 1;
};

export { mapAvatar, sortByOwner };
export type { AvatarProps };
